import {useLocation as useClientLocation} from "react-router-dom";
import {isServer} from "../constants/isServer";
import useSSRLocation from "./useSSRLocation";

const useLocation = isServer ? useSSRLocation : useClientLocation;

const useQuery = ():{ [key:string]: string } => {
  const params = new URLSearchParams(useLocation().search);
  return Array.from(params).reduce((result, [key, value]) => ({
    ...result,
    [key]: value,
  }), {});
};

export default useQuery;
import {useLocation as useClientLocation} from "react-router-dom";
import {isServer} from "../constants/isServer";
import useSSRLocation from "./useSSRLocation";

const useLocation = isServer ? useSSRLocation : useClientLocation;

const useQuery = ():{ [key:string]: string } => {
  const params = new URLSearchParams(useLocation().search);
  return Array.from(params).reduce((result, [key, value]) => ({
    ...result,
    [key]: value,
  }), {});
};

export default useQuery;
